var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatientwating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 107.144,
    viewBox: "0 0 74 107.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    transform: "translate(-134.886 -254.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(134.886 254.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "waiting-room",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M292.282,0A14.948,14.948,0,1,0,307.23,14.948,14.965,14.965,0,0,0,292.282,0Zm0,26.159a11.211,11.211,0,1,1,11.211-11.211A11.223,11.223,0,0,1,292.282,26.159Z",
    transform: "translate(-233.23)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M355.737,49.367V44.535a1.868,1.868,0,1,0-3.737,0V50.14a1.867,1.867,0,0,0,.547,1.321l1.869,1.869a1.868,1.868,0,0,0,2.642-2.642Z",
    transform: "translate(-296.251 -35.192)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M99.894,154.159H90.159a3.742,3.742,0,0,1-3.737-3.737V135.474a7.474,7.474,0,0,0-14.948,0v20.554a13.025,13.025,0,0,0,3.955,9.343H71.474a3.742,3.742,0,0,1-3.737-3.737V129.869a1.868,1.868,0,1,0-3.737,0v31.765a7.482,7.482,0,0,0,7.474,7.474h3.737V191.53H69.606a1.869,1.869,0,1,0,0,3.737H84.554a1.869,1.869,0,0,0,0-3.737H78.948V169.107H93.9v20.347a5.813,5.813,0,0,0,11.587.67L108.79,164.1a8.952,8.952,0,0,0-8.9-9.941Zm5.184,9.5-3.306,26.026a2.076,2.076,0,0,1-4.138-.228V167.239a1.868,1.868,0,0,0-1.869-1.869H84.554a9.354,9.354,0,0,1-9.343-9.343V135.474a3.737,3.737,0,1,1,7.474,0v14.948a7.482,7.482,0,0,0,7.474,7.474h9.735a5.22,5.22,0,0,1,5.213,5.213A5.053,5.053,0,0,1,105.078,163.657Z",
    transform: "translate(-64 -88.123)",
    fill: "#0060a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M116.01,18.685a9.343,9.343,0,1,0-9.343-9.343A9.354,9.354,0,0,0,116.01,18.685Zm0-14.948A5.606,5.606,0,1,1,110.4,9.343,5.612,5.612,0,0,1,116.01,3.737Z",
    transform: "translate(-99.193 16.795)",
    fill: "#0060a6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientwating);
export default __webpack_public_path__ + "static/media/patientwating.07b56f0ffe8bab55fc826ef60b749e4e.svg";
export { ForwardRef as ReactComponent };